import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InputField from '../InputField';

function TinInputField({
  grid,
  borderradius,
  border,
  padding,
  bgcolor,
  required,
  requiredcolor,
  placeholdercolor,
  pib,
  handleChange,
  errorMessage,
  requiredError,
  margin,
}) {
  const { t } = useTranslation();

  return (
    <InputField
      name="tin"
      grid={grid}
      required={required}
      type="text"
      placeholder={t('Tin')}
      label={t('Tin')}
      borderradius={borderradius}
      border={border}
      padding={padding}
      bgcolor={bgcolor}
      placeholdercolor={placeholdercolor}
      requiredcolor={requiredcolor}
      defaultValue={pib}
      handleChange={handleChange}
      errorMessage={errorMessage}
      requiredError={requiredError}
      margin={margin}
    />
  );
}

TinInputField.propTypes = {
  grid: PropTypes.number,
  padding: PropTypes.string,
  borderradius: PropTypes.number,
  bgcolor: PropTypes.string,
  border: PropTypes.string,
  required: PropTypes.bool,
  placeholdercolor: PropTypes.string,
  requiredcolor: PropTypes.string,
  pib: PropTypes.string,
  handleChange: PropTypes.func,
  errorMessage: PropTypes.string,
  requiredError: PropTypes.bool,
  margin: PropTypes.string,
};

TinInputField.defaultProps = {
  grid: 12,
  padding: '',
  borderradius: 0,
  bgcolor: '#fff',
  border: '',
  required: false,
  placeholdercolor: '#efefef',
  requiredcolor: '#fff',
  pib: '',
  requiredError: false,
  margin: '0px',
};

export default TinInputField;
